import { Divider, Space } from 'antd';
import { DynamicObjectType } from 'core/types/common';
import React, { Fragment, useMemo } from 'react';
import { formatMoney } from 'utils/formattedString';
import { CardWrapper } from './styles';

const PaymentInformation = ({ data }: { data: DynamicObjectType }) => {
  const paymentInformation = useMemo(
    () => [
      {
        title: 'Total return amount',
        value: formatMoney(data?.returnItemsValue || 0),
      },
      {
        title: 'Total new order amount',
        value: formatMoney(data?.newOrderItemsValue || 0),
      },
      {
        title: 'Delivery fees',
        value: formatMoney(Number(data?.shippingFee) || 0),
        hasDivider: true,
      },
      {
        title: 'Total payment',
        value: formatMoney(
          data?.newOrderItemsValue - data?.returnItemsValue < 0
            ? 0 + Number(data?.shippingFee)
            : data?.newOrderItemsValue -
                data?.returnItemsValue +
                Number(data?.shippingFee) || 0,
        ),
        fontValue: 'font-bold',
        fontTitle: 'font-bold',
      },
    ],
    [data],
  );
  return (
    <CardWrapper title="Payment Information">
      <Space className="w-full" size={10} direction="vertical">
        {paymentInformation?.map((item: DynamicObjectType, index: number) => {
          return (
            <Item
              key={index}
              title={item?.title}
              value={item?.value}
              fontValue={item?.fontValue}
              fontTitle={item?.fontTitle}
              hasDivider={item?.hasDivider}
            />
          );
        })}
      </Space>
    </CardWrapper>
  );
};

const Item = ({
  title,
  value,
  fontValue,
  fontTitle,
  hasDivider,
}: {
  title: string;
  value: string | number;
  fontValue?: string;
  fontTitle?: string;
  hasDivider?: boolean;
}) => {
  return (
    <Fragment>
      <div className="flex items-center justify-between">
        <div className={`text-sm ${fontTitle}`}>{title}</div>
        <div className={`text-sm ${fontValue}`}>{value}</div>
      </div>
      {hasDivider && <Divider className="w-full my-3" />}
    </Fragment>
  );
};

export default PaymentInformation;
